import { InputTextArea, Text } from '@spark';
import { isGenerativeTask } from '@/shared/domain/taskTypes';
import BenchmarkDistributionNestedTable from './BenchmarkDistributionNestedTable';
import {
  displayPromptOrSchema,
  getBenchmarkSections,
  resolveStudentField,
} from './benchmarkDistributionSections';

const TEACHER_FIELDS = [
  { key: 'system', label: 'System Prompt Used', teacherKey: 'teacher_system_prompt' },
  { key: 'prompt', label: 'Prompt Used', teacherKey: 'instruction' },
  { key: 'schema', label: 'JSON Schema', teacherKey: 'teacher_schema' },
];

const STUDENT_FIELDS = [
  {
    key: 'student-system',
    label: 'System Prompt Used',
    overrideKey: 'generative_student_instructions',
    teacherKey: 'teacher_system_prompt',
  },
  {
    key: 'student-prompt',
    label: 'Prompt Used',
    overrideKey: 'generative_student_prompt',
    teacherKey: 'instruction',
  },
  {
    key: 'student-schema',
    label: 'JSON Schema',
    overrideKey: 'generative_schema',
    teacherKey: 'teacher_schema',
  },
];

function PromptSchemaFields({ fields, record, resolveValue }) {
  return (
    <div className="spark-datatable-expanded-fields">
      {fields.map((field) => (
        <div key={field.key} className="spark-datatable-expanded-field">
          <InputTextArea
            label={field.label}
            value={resolveValue(field, record)}
            readOnly
            stretch
            showHelperText={false}
            showCharCount={false}
          />
        </div>
      ))}
    </div>
  );
}

export default function BenchmarkVersionExpandedDetails({ record, taskType }) {
  const sections = getBenchmarkSections(taskType, record).filter(
    (section) => section.rows.length > 0,
  );
  const showStudent =
    isGenerativeTask(taskType) && record?.include_instruction_in_training === true;

  return (
    <div className="spark-datatable-expanded-stack">
      {sections.map((section) => (
        <BenchmarkDistributionNestedTable
          key={section.title}
          title={section.title}
          nameColumnHeader={section.nameColumnHeader}
          rows={section.rows}
        />
      ))}
      <PromptSchemaFields
        fields={TEACHER_FIELDS}
        record={record}
        resolveValue={(field, row) => displayPromptOrSchema(row?.[field.teacherKey])}
      />
      {showStudent ? (
        <div className="spark-datatable-expanded-section">
          <Text variant="base-semibold" color="primary" as="p">
            Student
          </Text>
          <PromptSchemaFields
            fields={STUDENT_FIELDS}
            record={record}
            resolveValue={(field, row) =>
              resolveStudentField(row, field.overrideKey, field.teacherKey)
            }
          />
        </div>
      ) : null}
    </div>
  );
}
